<template>
  <div class="main-title">
    <p class="title green_text">
      <span class="no green_bg">{{ index }}</span>
      <span
        ><strong><slot/></strong>
        <el-textarea
          :parent_data="parent_data"
          :property="property"
          :editable="editable"
          placeholder="Modifier le titre..."
          class="textarea-title"
          :max-length="130"
        />
      </span>
    </p>
  </div>
</template>

<script>
import ElTextarea from "@/components/study/editor/elements/el-textarea";

export default {
	components: {
		ElTextarea
	},
	props: {
		index: null,
		parent_data: null,
		property: {default: ""},
		editable: {default: false}
	},
};
</script>
